import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

const getCustomerGroupMapping = (rows) => {
  return rows.reduce((acc, row) => {
    if (!acc[row.CustomerGroupId]) {
      acc[row.CustomerGroupId] = [];
    }
    acc[row.CustomerGroupId].push(row);
    return acc;
  }, {});
};



const CustomerGroupColumn = ({ row, value, column: { rows } }) => {
  const customerGroupMapping = useMemo(() => getCustomerGroupMapping(rows), [rows]);

  const resolvedRow = row ?? rows.find((row) => row.CustomerGroupId === value);

  const customerGroupName = resolvedRow?.CustomerGroupAssignments?.find(
    (cga) => cga.CustomerGroup.Id === resolvedRow.CustomerGroupId
  )?.CustomerGroup.Name || '';

  const groupCount = customerGroupMapping[value]?.length || 0;

  return (
    <>
      {customerGroupName}
      <span style={{ fontWeight: 'bold' }}> ({groupCount})</span>
    </>
  );
};

CustomerGroupColumn.propTypes = {
  row: PropTypes.object,
  value: PropTypes.number,
  column: PropTypes.shape({
    rows: PropTypes.array.isRequired,
  }).isRequired,
};

export default CustomerGroupColumn;
